module.exports = __webpack_public_path__ + "img/materialdesignicons-webfont.07c3c549.svg";